'use strict';
import { react2angular } from 'react2angular';
import InvoiceHeaderWrapper from '../../src/views/invoice-details/components/invoice-header/InvoiceHeaderWrapper';

angular
    .module('dstreamApp.reactBridge')
    .component('dsInvoiceHeader', react2angular(InvoiceHeaderWrapper, ['invoice', 'approveInvoice', 'getInvoiceData', 'getMinimalInvoiceData', 'reloadInvoiceData', 'saveWorkflowInvoice', 'updateSupplierId', 'getCompaniesFromTheSameOrganizationByName', 'removeDuplicateFlag'], ['$rootScope']));
